import Vue from "vue";

Vue.filter('encrypt', (value, type) => {
  if (/^\d{11}$/.test(value) && type === 'phone') {
    return (value + '').replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
  } else if (type === 'name') {
    return value.slice(0, 1) + '**';
  }
  return value;
});

Vue.filter('money', (value, divide) => {
  if (isNaN(value) || value === null) {
    return '--';
  }
  return (+value / (divide || 100)).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
});



// WEBPACK FOOTER //
// ./src/components/core/registerFilter.js